import 'whatwg-fetch'
import { Broker } from './utils/broker'
import { createCmp } from './cmp/Cmp'
import Ui from './ui/Ui'
import { createLog } from './utils/logger'
import clientApi from './clientApi'
import loadStorageIframe from './storage-iframe'
import Persist from './persist/Persist'
import { createConfig } from './config/config'

// https://vendorlist.consensu.org/v2/vendor-list.json

const log = createLog()

function createUi (broker, config) {
  const { uiLevel, renderPlatform, brand, uiScriptUrl } = config.get()
  return new Ui({ uiLevel, renderPlatform, brand, uiScriptUrl, clientBroker: broker })
}

async function fetchVendor (url) {
  const response = await fetch(url)
  return response.json()
}

async function fetchVendorData (gvlVersion, cvlVersion = '0.0.1') {
  const gvlUrl = `//cmp.dmgmediaprivacy.co.uk/gvl/${gvlVersion}/vendor-list.json`
  const cvlUrl = `//cmp.dmgmediaprivacy.co.uk/custom/${cvlVersion}/vendor-list.json`
  return Promise.all([fetchVendor(gvlUrl), fetchVendor(cvlUrl)])
}

async function launch (broker, config) {
  const clientConfig = config.get()
  const { brokerId, controllerScriptBase, cvlVersion, backendUrl, channel, platform, renderPlatform, storeUserPreference, persistCustomVendors, uuid } = clientConfig
  const { tcData, iframe, customVendors } = !!config.get('storeUserPreference') && await loadStorageIframe(broker, brokerId, controllerScriptBase)
  const userPreferences = config.getUserPreferences(tcData, customVendors)
  const { gvlVersion, gvlUiVersion } = config.getGVLVersions(userPreferences.tcString)
  const [gvlJson, cvlJson] = await fetchVendorData(gvlVersion, cvlVersion)
  const persist = new Persist({ backendUrl, channel, platform: platform || renderPlatform })
  const ui = createUi(broker, config)
  const cmpOpts = {
    gvlJson,
    cvlJson,
    storeTcString: storeUserPreference,
    persist,
    persistCustomVendors,
    ui,
    uuid,
    gvlVersion,
    gvlUiVersion,
    ...userPreferences
  }
  const cmp = await createCmp(cmpOpts)
  log(`${userPreferences.tcString ? 'Existing' : 'New'} User`, cmp.tcModel)
  const showUi = (clientConfig.showUi === 'true' || clientConfig.showUi === true)
  broker.emit('is_loaded')
  const message = {
    ns: '@mol-ads/mol-ads-cmp',
    id: brokerId,
    sender: 'mol-ads/mol-ads-cmp',
    action: 'is_loaded'
  }
  if (iframe) {
    iframe.contentWindow.postMessage(message, '*')
  }

  await cmp.isReady()
  clientApi(broker, cmp, ui)
  if (showUi) {
    cmp.openUi(clientConfig.uiLevel)
  } else {
    cmp.notifyUsersPreferences()
  }
  broker.emit('is_ready')
}

setTimeout(() => {
  const config = createConfig()
  const brokerId = config.get('brokerId')
  const broker = new Broker('@mol-ads/mol-ads-cmp', 'mol-ads-cmp', brokerId)
  launch(broker, config)
}, 10)
